import { useEffect } from 'react'

import { useDebounce } from '@skytech/utils'

import { FilterInput } from '@/components/form/Input'
import { useTranslation } from '@/components/i18n/hooks'
import Hits from '@/components/primitives/Hits'
import { useSearchParamsByKey } from '@/hooks/searchParams'

import { useInjuryReportsList } from '../hooks'
import { useInjuryReportsContext } from '../index.context'

import StatusSelect from './StatusSelect'
import StatusTabs from './StatusTabs'

const sortFn = (a: number, b: number) => a - b

const InjuryReportListFilters = () => {
  const translate = useTranslation()
  const { searchFilter, setSearchFilter } = useInjuryReportsContext()
  const { statusCounter, numberOfInjuryReports, isLoading, isError } = useInjuryReportsList()
  const [querySearch, setQuerySearch] = useSearchParamsByKey('search')
  const debouncedSearchTerm = useDebounce(searchFilter, 500)

  useEffect(() => {
    setSearchFilter(querySearch || '')
  }, [querySearch])

  useEffect(() => {
    setQuerySearch(debouncedSearchTerm)
  }, [debouncedSearchTerm])

  if (isError) return null

  const sortedStatuses = Object.keys(statusCounter)
    .map(key => Number(key))
    .sort(sortFn)

  return (
    <div className="device-order-filter">
      <StatusTabs sortedStatuses={sortedStatuses} isLoading={isLoading} />

      <StatusSelect sortedStatuses={sortedStatuses} />

      <FilterInput
        type="text"
        placeholder={translate('filter injury reports')}
        value={searchFilter}
        onChange={e => {
          const text = e.target.value
          setSearchFilter(text)
        }}
      />

      <Hits amount={numberOfInjuryReports} />
    </div>
  )
}

export default InjuryReportListFilters
